/* global */
import React, { useState, useCallback, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { css as uicss, ShowMore } from 'panamera-react-ui';
import classNames from 'classnames';
import { FormattedMessage as Translation } from 'react-intl';
import withRouter from 'HOCs/withRouter';
import withTags from 'HOCs/withTags/withTags';
import { routerParamsToSeoQuery } from 'Helpers/listing';
import Icon from 'Components/ThematicIcon/ThematicIcon';
import css from './SeoTextMX.APP_TARGET.scss';
import { setDynamicSeoTextHeightContent } from './helpers';

const { grid } = uicss;

export const SeoTextMX = ({ seoText }) => {
    const [seoTextPanelOpen, setToggleSeoPanel] = useState(false);
    const showMoreContent = useRef(null);

    const handleSeoTogglePanel = useCallback(() => {
        setToggleSeoPanel(prevState => !prevState);
    }, []);

    const renderSeoTextIcon = (id = 'viewMore', icon = 'arrowDown') => {
        return (
            <div className={ css.seoTextShowButton } onClick={ handleSeoTogglePanel } data-aut-id="seoTextActionLink">
                <Translation id={ id } />
                <Icon icon={ icon } size={ 20 } fill="primary" />
            </div>
        );
    };

    const renderSeoTextButton = () => {
        return {
            more: renderSeoTextIcon(),
            less: renderSeoTextIcon('viewLess', 'arrowUp')
        };
    };

    useEffect(() => {
        if (showMoreContent?.current) {
            setDynamicSeoTextHeightContent(seoTextPanelOpen);
        }
    }, [seoTextPanelOpen, showMoreContent]);

    if (!seoText) {
        return null;
    }

    return (
        <div className={ classNames(grid.row, css.seoText) }>
            <ShowMore
                ref={ showMoreContent }
                dataAutId="seoTextShowMore"
                placeholder={ seoText.text }
                { ...renderSeoTextButton() }
                markdown={ true }
            />
        </div>
    );
};

SeoTextMX.propTypes = {
    seoText: PropTypes.exact({
        title: PropTypes.string,
        text: PropTypes.string
    }),
    config: PropTypes.shape({
        get: PropTypes.func.isRequired
    })
};

export default compose(
    withRouter,
    withTags('listing', routerParamsToSeoQuery, { withHelmet: false })
)(SeoTextMX);
